export default "__VITE_ASSET__brJGep2N__"